import { render, staticRenderFns } from "./AuthoriseMiscOld.vue?vue&type=template&id=531ac3b2&scoped=true"
import script from "./AuthoriseMiscOld.vue?vue&type=script&lang=js"
export * from "./AuthoriseMiscOld.vue?vue&type=script&lang=js"
import style0 from "./AuthoriseMiscOld.vue?vue&type=style&index=0&id=531ac3b2&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "531ac3b2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('531ac3b2')) {
      api.createRecord('531ac3b2', component.options)
    } else {
      api.reload('531ac3b2', component.options)
    }
    module.hot.accept("./AuthoriseMiscOld.vue?vue&type=template&id=531ac3b2&scoped=true", function () {
      api.rerender('531ac3b2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/quote/components/AuthoriseMiscOld.vue"
export default component.exports